import { CircleLoader, CircleLoaderSize } from '@/components/ui/loaders/circle-loader/CircleLoader';
import { resolveLogoSrc } from '@/lib/theme-utils';

interface FullScreenLoaderProps {
  text?: string;
  logo?: string;
  /** Test hook placed on the root element. Defaults to `"full-screen-loader"` (PB-3325). */
  'data-cy'?: string;
}

export function FullScreenLoader({ logo, 'data-cy': dataCy = 'full-screen-loader' }: FullScreenLoaderProps) {
  const logoSrc = logo?.trim() ? resolveLogoSrc(logo) : undefined;

  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading"
      data-cy={dataCy}
      className="tw:flex tw:h-dvh tw:w-full tw:flex-col tw:items-center tw:justify-center tw:bg-gray-white"
    >
      {/* {logoSrc ? (
        <div className="tw:flex tw:h-[100px] tw:w-[212px] tw:items-center tw:justify-center">
          <img
            src={logoSrc}
            alt="Company logo"
            className="animate-fade-in tw:max-h-[72px] tw:max-w-[100px] tw:object-contain"
          />
        </div>
      ) : ( */}
      <CircleLoader size={CircleLoaderSize.large} className="tw:h-10 tw:w-10" />
      {/* )} */}
      <div className="tw:mt-[var(--spacing-base)] tw:text-14 tw:text-gray-dark tw:animate-pulse-fade">
        <span>Getting things parked..</span>
      </div>
    </div>
  );
}
